import React from 'react';
import PropTypes from 'prop-types';
import { EditableText } from '../Elements';
import { MobileModal } from '../Modules';
import {
  Button,
  Checkbox,
  Dropdown,
  Icon,
  Menu,
  Modal
} from 'semantic-ui-react';
import styles from './Playlist.scss';
import { RootConsumer } from '../RootComponent';
import Artwork from './Artwork';

export default class PlaylistSummary extends React.Component {
  static propTypes = {
    editable: PropTypes.bool,
    goBack: PropTypes.func,
    playlist: PropTypes.object.isRequired,
    showControls: PropTypes.bool,
    updatePlaylist: PropTypes.func,
    updateMaxLength: PropTypes.func,
    deletePlaylist: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      deleteConfirmationOpen: false,
      deleting: false,
      limitPlaylistSize: this.props.playlist.max_length !== null
    };
    this.deletePlaylist = this.deletePlaylist.bind(this);
    this.toggleLimitPlaylistSize = this.toggleLimitPlaylistSize.bind(this);
  }

  deletePlaylist() {
    this.setState({ deleting: true });
    if (this.props.goBack) this.props.goBack();
    this.props.deletePlaylist();
  }

  toggleLimitPlaylistSize() {
    const numSongs = this.props.playlist.playlist_songs.edges.length;
    const { limitPlaylistSize } = this.state;
    const successCb = () =>
      this.setState({ limitPlaylistSize: !limitPlaylistSize });
    if (limitPlaylistSize) {
      this.props.updateMaxLength(
        { value: null, name: 'max_length' },
        successCb
      );
    } else {
      const value = numSongs >= 10 ? numSongs + 5 : 10;
      this.props.updateMaxLength({ value, name: 'max_length' }, successCb);
    }
  }

  render() {
    const {
      editable,
      goBack,
      playlist,
      showControls = true,
      updatePlaylist,
      updateMaxLength,
      deletePlaylist
    } = this.props;
    const { deleting, deleteConfirmationOpen, limitPlaylistSize } = this.state;
    const numSongs = playlist.playlist_songs.edges.length;

    const DeleteConfirmation = (
      <Modal
        open={deleteConfirmationOpen}
        onClose={() => this.setState({ deleteConfirmationOpen: false })}
        size='small'
      >
        <Modal.Header content='Delete Playlist' />
        <Modal.Content>
          <h3>
            Are you sure you want to {editable ? 'delete' : 'unfollow'}{' '}
            {playlist.title}?
          </h3>
        </Modal.Content>
        <Modal.Actions>
          <Button
            basic
            onClick={() => this.setState({ deleteConfirmationOpen: false })}
          >
            Cancel
          </Button>
          <Button color='red' onClick={this.deletePlaylist} disabled={deleting}>
            <Icon name='delete' /> Delete
          </Button>
        </Modal.Actions>
      </Modal>
    );

    const OptionsMenu = (
      <Dropdown.Menu style={{ left: 'auto', right: 0 }}>
        <Dropdown.Item
          onClick={() => {
            if (this.props.editable) {
              this.setState({ deleteConfirmationOpen: true });
            } else {
              this.deletePlaylist();
            }
          }}
        >
          <span className={styles.delete}>
            {editable ? 'Delete' : 'Unfollow'} Playlist
          </span>
        </Dropdown.Item>
      </Dropdown.Menu>
    );
    return (
      <RootConsumer>
        {({ isMobile }) =>
          <div style={isMobile ? null : { display: 'flex' }}>
            {isMobile &&
              <MobileModal.Header>
                <div className='menu'>
                  <a className='item' onClick={goBack}>
                    <Icon name='chevron left' />
                  </a>
                </div>
                {showControls &&
                  deletePlaylist &&
                  <div className='menu right'>
                    <Dropdown
                      floating
                      icon='ellipsis vertical'
                      labeled
                      item
                      className={'icon basic'}
                      style={{ padding: '1em 2em' }}
                    >
                      {OptionsMenu}
                    </Dropdown>
                  </div>}
              </MobileModal.Header>}
            <Artwork playlist={playlist} />
            <div
              style={
                isMobile
                  ? { paddingTop: '1em', paddingRight: '1.5em' }
                  : { flex: 1, paddingLeft: '2em', paddingRight: '1.5em' }
              }
            >
              <h2
                className={[playlist.title ? '' : styles.muted].join(' ')}
                style={{ margin: 0 }}
              >
                {editable &&
                  <EditableText
                    value={playlist.title}
                    update={updatePlaylist}
                    placeholder='Playlist Title'
                    name='title'
                    fluid
                    autoHeight
                  />}
                {!editable && playlist.title}
              </h2>
              <div style={{ marginTop: '0.5em' }}>
                {editable &&
                  <EditableText
                    value={playlist.description}
                    update={updatePlaylist}
                    placeholder='Playlist description...'
                    name='description'
                    fluid
                    autoHeight
                  />}
                {!editable && playlist.description}
              </div>
              {updateMaxLength &&
                <div style={{ marginTop: '0.5em' }}>
                  {editable &&
                    <div>
                      <Checkbox
                        size='tiny'
                        toggle
                        label='Limit Playlist Size'
                        checked={limitPlaylistSize}
                        onClick={this.toggleLimitPlaylistSize}
                      />
                      {limitPlaylistSize &&
                        <div style={{ marginTop: '0.5em' }}>
                          Song Limit:
                          <EditableText
                            value={playlist.max_length}
                            update={updateMaxLength}
                            placeholder='Song Limit'
                            name='max_length'
                            type='number'
                            min={0}
                            style={{ marginLeft: '0.25em', width: '50px' }}
                          />
                        </div>}
                    </div>}
                </div>}
              <div className={styles.songCount}>
                {numSongs} {`song${numSongs !== 1 ? 's' : ''}`}
                {!editable &&
                  playlist.max_length &&
                  ` (Limit: ${playlist.max_length} song${numSongs !== 1
                    ? 's'
                    : ''})`}
              </div>
            </div>
            {showControls && DeleteConfirmation}
            {showControls &&
              deletePlaylist &&
              !isMobile &&
              <div>
                <Dropdown
                  floating
                  icon='ellipsis vertical'
                  labeled
                  className={`icon basic ${styles.playlistOptions}`}
                  direction='right'
                >
                  {OptionsMenu}
                </Dropdown>
              </div>}
          </div>}
      </RootConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Summary.js